export default __webpack_public_path__ + "assets/images/84aa8a9bdfc409061f286a5396cce6ac.png";